<template>
  <div class="listmain ">
      <h1 class="firTitle">技能商店</h1>
      <span>
 <!--<h3 class="sedTitle">技能商店 API 使用</h3>-->
<!--<p class="ql-long-7802039">-->
	<!--<span class="ql-author-7802039 ql-size-9">头文件 OrionSDK+OVSSkillStoreAPI.h</span>-->
<!--</p>-->

<!--<p class="ql-long-7802039">-->
	<!--<strong class="ql-author-7802039 ql-size-9">使用技能商店API，不需要再调用技能商店UI，可根据相关的参数获取技能详情。</strong>-->
<!--</p>-->

</span>
          <highlight-code lang="javascript">
             <span>
/**
 * @brief 技能开放平台
 */
@interface OrionSDK (SkillOpenPlatform)

/*!
 * @brief 技能商店列表
 * @param parameter 传参
 *        access_token // 用户access_token
 *        client_id    // 客户端ID
 *  @param completion  完成回调
 */
- (void)skillStoreWithOpenPlatformParameter:(NSDictionary *__nullable)parameter
                                 completion:(nullable void (^)(NSDictionary *__nullable skillInfo, NSError *__nullable error))completion;

/*!
 * @brief 技能详情
 * @param parameter 传参
 *        access_token // 用户access_token
 *        skill_id     // 技能ID
 *  @param completion  完成回调
 */
- (void)skillDetailWithOpenPlatformParameter:(NSDictionary *__nullable)parameter
                                  completion:(nullable void (^)(NSDictionary *__nullable skillInfo, NSError *__nullable error))completion;

@end
             </span>
    </highlight-code>
      <!--<h3 class="sedTitle">技能商店UI 使用</h3>-->
      <!--<p class="ql-long-7802039">-->
          <!--<span class="ql-author-7802039 ql-size-9">导入 OVSSkillStore.framework <br>-->
<!--以 viewControllerForURL 方式获取技能商店控制器，不支持 openURL 方式；</span>-->
      <!--</p>-->

      <!--<highlight-code lang="javascript">-->
        <!--<span>-->
            <!--+ (UIViewController *)fetchSkillStoreViewController {-->
    <!--// 路由URL 规则纯小写如 `ovs://skillstore`，ovs:// 前缀，后面加组件名称-->
    <!--NSURL *routeUrl = [NSURL URLWithString:@"ovs://skillstore"];-->
    <!--return [[OrionSDK shared] viewControllerForURL:routeUrl];-->
<!--}-->
        <!--</span>-->
      <!--</highlight-code>-->
      <h3 class="sedTitle">个性化闹钟</h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">个性化闹钟调用，需要引入 OVSSkillStore.framework。</span>
      </p>

      <highlight-code lang="javascript">
          [[OrionSDK shared] openURL:[NSURL URLWithString:@"ovs://alarm"]];
      </highlight-code>
      <h3 class="sedTitle">我的收藏</h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">收藏调用，需要引入 OVSSpeakerBasicPage.framework。</span>
      </p>

      <highlight-code lang="javascript">
          [[OrionSDK shared] openURL:[NSURL URLWithString:@"ovs://collect"]];
      </highlight-code>
     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Shop.vue